import { AuditLogEntry } from '../../../types';
import { Button } from '../../../components/ui/atoms/button';
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle } from '../../../components/ui/organisms/dialog';
import { formatTimestamp, targetTableLabel } from './utils';

export function AuditLogDetailDialog({ log }: { log: AuditLogEntry }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">View Details</Button>
      </DialogTrigger>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="capitalize">
            {log.action}: {targetTableLabel(log.targetTable)}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm">
          <div className="rounded-md border p-3 space-y-2">
            <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Target</p>
            <div className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1">
              <span className="text-muted-foreground">Table</span>
              <span className="font-medium">{targetTableLabel(log.targetTable)}</span>
              <span className="text-muted-foreground">ID</span>
              <span className="font-mono text-xs break-all">{log.targetId}</span>
              <span className="text-muted-foreground">Performed by</span>
              <span>{log.actor?.name ?? '—'} <span className="text-muted-foreground text-xs">({log.actor?.email})</span></span>
              <span className="text-muted-foreground">At</span>
              <span>{formatTimestamp(log.createdAt)}</span>
            </div>
          </div>
          <div className="space-y-1.5">
            <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Changes</p>
            {log.diff && Object.keys(log.diff).length > 0 ? (
              <pre className="max-h-64 overflow-auto rounded-md bg-slate-100 dark:bg-slate-800 p-3 text-xs">
                {JSON.stringify(log.diff, null, 2)}
              </pre>
            ) : (
              <p className="text-muted-foreground text-xs italic">No change data recorded for this action.</p>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
